import { createApp } from 'vue'
import App from './SafetyHealth.vue'

createApp(App).mount('#app-safety-health')
